import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ScrollRegionComponent } from '@brightside/angular-bds';

export const CARE_PLAN_CARD_LIST_MAX_HEIGHT = '20.25rem';

@Component({
  selector: 'bn-care-plan-card-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScrollRegionComponent],
  templateUrl: './care-plan-card-list.component.html',
  styleUrl: './care-plan-card-list.component.scss',
})
export class CarePlanCardListComponent {
  readonly ariaLabel = input.required<string>();
  protected readonly maxHeight = CARE_PLAN_CARD_LIST_MAX_HEIGHT;
}
